import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SimuladorRoutingModule } from './simulador-routing.module';
import { SimuladorComponent } from './simulador.component';
import { SimuladorPrimaryInterface } from '../../core/ports/primary/simulador.primary.interface';
import { SimuladorUsecase } from '../../core/usecases/simulador.usecase';
import { SimuladorSecondaryInterface } from '../../core/ports/secondary/simulador.secondaty.interface';
import { SimuladorService } from '../secondary/apirest/simulador.service';
import { NivelAcademicoComponent } from './nivel-academico/nivel-academico.component';
import { PrimengModule } from '../../../../shared/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResumenComponent } from './resumen/resumen.component';
import { ComponentsModule } from '../../../../components/components.module';

@NgModule({
  declarations: [SimuladorComponent, NivelAcademicoComponent, ResumenComponent],
  imports: [
    CommonModule,
    SimuladorRoutingModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
  ],
  providers: [
    { provide: SimuladorPrimaryInterface, useClass: SimuladorUsecase },
    { provide: SimuladorSecondaryInterface, useClass: SimuladorService },
  ],
})
export class SimuladorModule {}
